module.exports = __webpack_public_path__ + "static/media/gerb-2.a42dad7c.png";